module.exports = __webpack_public_path__ + "static/img/4.1b1b710.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/eng/4.png
// module id = ERKx
// module chunks = 0